import React from "react";

const AddPanelistModal = () =>{
  return(
    <>
    </>
  )
}

export default AddPanelistModal;